/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { UserView } from "./UserView";
import { GenericData } from "./Generic-Data";
import { TypedObject } from "./TypedObject";

export enum ProjectChange {
  NO_CHANGE = 0,
  FUNCTION_UNIT_OR_GEAR = 1,
  SIZING = 2,
  EDITING_COMPLETE = 3,
  TREND_GROUP = 4,
  TREND_VERSION = 5,
  SOLUTION_METHOD = 6,
  LABOR_RATE = 7,
  ACTIVE_PHASE = 8,
  COMPARISON_SOLUTION_CHANGE = 9,
  //xxxDELETE - xxAF: we may be able to combine the next 2 flags and the eventual 'LOG_EDITED' flag into one, e.g., SOLUTION_LOG_CHANGE
  CURRENT_SOLUTION_CHANGE = 10,
  SOLUTION_LOGGED = 11,
  SOLUTION_LOG_EDITED = 12,
  ADVANCE = 13,
  SAVE = 14,
  ASSOCIATEDWORKBOOK = 15,
  CONTINGENCY_SETTINGS = 16,
  SAVEAS = 17,
  TRENDCONFIRM = 18,
  HISTORY_PROJECTS_CHANGE = 19,
  REVERT = 20
}

export class ProjectInfo { }
export class SolutionInfo { }
export class EstimateSoln { }

export class ProjectUserInfo {
  public Id: number = 0;
  public accessLevelId: number = 0;
  public accessLevelName: string = "";
  public userName: string = "";
  public deniedAccess: boolean = false;  //not sent from server, set within Angular app
}

// zzzASC - Keep in sync with ProjectViewModel defined in iSlim.Collab/Models/ProjectViewModel.cs
export class ProjectViewModel {
  public Project: ProjectInfo;
  public SizeIsValid: boolean = true;
  public User: UserView;
  public SolutionIsReasonable: boolean = true;
  public UserCanUpdateAssociatedWorkbook: boolean;
  public AssociatedWorkbookValid: boolean;
  public ExternalUrl: string;
  public ChangeType: ProjectChange = ProjectChange.NO_CHANGE;
  public Message: string;
  public Committed: boolean | null = null;
  public Extra: TypedObject = null;
  public TrendVersionNeedsConfirmation: boolean;
  public CurrentTrendVersionName: string;
  public DefaultTrendVersionName: string;
}

export class CommittedProjectData {
  public ProjectId: number = 0;
  public PrimaryResponsibilityId: number = 0;
}
